// src/components/organisms/Header/Navbar.tsx
import React, { useState } from 'react';
import { Link, useNavigate, useLocation, matchPath } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import { FiChevronDown } from 'react-icons/fi';
import { useTranslation } from "react-i18next";
import logoFull from '../../../assets/villasflamingos-logo.svg';
import { routeMap } from '../../../config/routes';

interface NavbarProps {
  toggleMenu: () => void;
  isScrolled: boolean;
  onReserveClick: () => void;
  onLoginClick: () => void; // Nueva prop
}

const Navbar: React.FC<NavbarProps> = ({ toggleMenu, onReserveClick, onLoginClick }) => {
  const [languageOpen, setLanguageOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const currentLang = i18n.language.split("-")[0] as "es" | "en";

  const toggleLanguage = (targetLang: "es" | "en") => {
    let newPath = `/${targetLang}`;
    const activeRouteKey = Object.keys(routeMap).find((key) => {
      const currentRouteConfig = routeMap[key as keyof typeof routeMap];
      const pathPattern = `/${currentLang}/${currentRouteConfig[currentLang]}`;
      return matchPath(pathPattern, location.pathname);
    });

    if (activeRouteKey) {
      const routeConfig = routeMap[activeRouteKey as keyof typeof routeMap];
      const currentPattern = `/${currentLang}/${routeConfig[currentLang]}`;
      const match = matchPath(currentPattern, location.pathname);
      const params = match?.params || {};
      let targetPattern = routeConfig[targetLang];
      Object.keys(params).forEach((paramKey) => {
        targetPattern = targetPattern.replace(`:${paramKey}`, params[paramKey] || '');
      });
      newPath = `/${targetLang}/${targetPattern}`;
    } else {
      newPath = `/${targetLang}/${routeMap.home[targetLang]}`;
    }

    i18n.changeLanguage(targetLang);
    navigate(newPath);
    setLanguageOpen(false);
  };

  return (
    <div className="navbar-content">
      <div className="navbar-left">
        <button className="menu-toggle" onClick={toggleMenu}>
          <span className="menu-icon"></span>
          <span className="menu-icon"></span>
          <span className="menu-icon"></span>
        </button>
        <a href="https://api.whatsapp.com/send/?phone=5219841250102" target="_blank" rel="noopener noreferrer" className="navbar-icon-link">
          <FaWhatsapp size={35} />
        </a>
      </div>

      <div className="navbar-center">
        <Link to={`/${currentLang}/${routeMap.home[currentLang]}`}>
          <img src={logoFull} alt="Villas Flamingos Logo" className="logo" />
        </Link>
      </div>

      <div className="navbar-right">
        <button
          onClick={(e) => { e.preventDefault(); onReserveClick(); }}
          className="nav-button anim-box-reverse"
          style={{ cursor: 'pointer' }}
        >
          {t('navbar:reserve')}
          <span className="line line-top"></span>
          <span className="line line-bottom"></span>
        </button>

        <div className={`language-selector ${languageOpen ? "open" : ""}`} onClick={() => setLanguageOpen(!languageOpen)}>
          <span className="language-text">{currentLang.toUpperCase()}</span>
          <FiChevronDown size={14} className={`language-arrow ${languageOpen ? "open" : ""}`} />
          {languageOpen && (
            <div className="language-dropdown">
              {currentLang !== "es" && <button onClick={(e) => { e.stopPropagation(); toggleLanguage("es"); }}>ES</button>}
              {currentLang !== "en" && <button onClick={(e) => { e.stopPropagation(); toggleLanguage("en"); }}>EN</button>}
            </div>
          )}
        </div>

        {/* BOTÓN DE LOGIN CONECTADO AL MODAL */}
        <button
          onClick={(e) => { e.preventDefault(); onLoginClick(); }}
          className="nav-button anim-box-reverse access"
          style={{ cursor: 'pointer', background: 'none', border: 'none' }}
        >
          <span>{t('navbar:login')}</span>
          <span className="line line-top"></span>
          <span className="line line-bottom"></span>
        </button>
      </div>
    </div>
  );
};

export default Navbar;